package org.lennycodes.hldi.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.textAlign
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.style.breakpoint.ResponsiveValues
import com.varabyte.kobweb.silk.style.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.browser.window
import org.jetbrains.compose.web.css.color
import org.jetbrains.compose.web.css.fontSize
import org.jetbrains.compose.web.css.maxWidth
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.textAlign
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Section
import org.jetbrains.compose.web.dom.Text
import org.lennycodes.hldi.components.CustomSection
import org.lennycodes.hldi.components.ResourceCard
import org.lennycodes.hldi.constants.HLDITheme
import org.lennycodes.hldi.data.ResourceDocument
import org.lennycodes.hldi.layouts.MainLayout
import org.lennycodes.hldi.pages.admin.AdminRepository
import org.lennycodes.hldi.styles.AboutHeroSectionStyle
import org.lennycodes.hldi.styles.AboutHeroTextStyle
import org.lennycodes.hldi.styles.AboutHeroTitleStyle
import org.lennycodes.hldi.styles.SectionWaveSvg
import org.lennycodes.hldi.styles.SpinnerStyle

@Composable
@Page("/resources")
fun ResourcesPage() {

    var isLoading by remember { mutableStateOf(true) }

    var resources by remember {
        mutableStateOf<List<ResourceDocument>>(emptyList())
    }

    LaunchedEffect(Unit) {

        try {

            resources = AdminRepository.getAllResources()

        } finally {

            isLoading = false

        }

    }

    MainLayout {

        // Hero Section
        Section(
            attrs = Modifier
                .padding(50.px, 20.px)
                .then(AboutHeroSectionStyle.toModifier())
                .toAttrs()
        ) {
            H1(attrs = AboutHeroTitleStyle.toAttrs()) {
                Text("Our Resources & Documentation")
            }

            P(
                attrs = AboutHeroTextStyle.toAttrs {
                    style { maxWidth(700.px) }
                }
            ) {
                Text(
                    "Access HLDI reports, policies, publications, and official documents that showcase our work, impact, partnerships, and commitment to transparency."
                )
            }

            SectionWaveSvg()
        }

        // Resources Section
        CustomSection(
            title = "Documents & Publications",
            subtitle = "Explore our annual reports, policies, project documents, and publications that provide insight into our humanitarian programs and achievements."
        ) {

            when {

                isLoading -> {

                    Div(
                        attrs = Modifier
                            .fillMaxWidth()
                            .padding(40.px)
                            .toAttrs {
                                style {
                                    property("display", "flex")
                                    property("justify-content", "center")
                                    property("align-items", "center")
                                }
                            }
                    ) {

                        Div(
                            attrs = Modifier
                                .size(45.px)
                                .then(SpinnerStyle.toModifier())
                                .toAttrs()
                        )

                    }

                }

                resources.isEmpty() -> {

                    P(
                        attrs = {
                            style {
                                textAlign(TextAlign.Center)
                                fontSize(16.px)
                                color(HLDITheme.Colors.mediumGray)
                            }
                        }
                    ) {
                        Text("No resources available yet.")
                    }

                }

                else -> {

                    SimpleGrid(
                        numColumns = ResponsiveValues(
                            1, // xs
                            1, // sm
                            2, // md
                            3, // lg
                            3,
                            3
                        ),
                        modifier = Modifier.gap(32.px)
                    ) {

                        resources.forEach { resource ->

                            ResourceCard(
                                resource = resource,
                                onView = {
                                    window.open(resource.fileUrl, "_blank")
                                },
                                onDownload = {
                                    window.open(resource.fileUrl, "_blank")
                                }
                            )

                        }

                    }

                }

            }

        }

    }

}